import { render, staticRenderFns } from "./CountTo.vue?vue&type=template&id=c97dea78&scoped=true&"
import script from "./CountTo.vue?vue&type=script&lang=ts&"
export * from "./CountTo.vue?vue&type=script&lang=ts&"
import style0 from "./CountTo.vue?vue&type=style&index=0&id=c97dea78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97dea78",
  null
  
)

export default component.exports